module.exports = __webpack_public_path__ + "images/5ecefa4e87b3bb8bc834ac632da09b36.png";